














































import { Mixins, Component } from 'vue-mixin-decorator';
import CardOverlay from '@/components/CardOverlay.vue';
import BannerGrid from '@/components/BannerGrid.vue';
import LuanchGameMixin from '@/mixins/luanchGameMixin';
import AuthConnector from '@/connector/Auth.vue';
import DialogConnector from '@/connector/Dialog.vue';

@Component({
  components: {
    CardOverlay,
    BannerGrid,
    AuthConnector,
    DialogConnector,
  },
})
export default class SlotPage extends Mixins<LuanchGameMixin>(LuanchGameMixin) {
  // eslint-disable-next-line class-methods-use-this
  get games(): string[] {
    return [
      'caishen_wins',
      'deadwood',
      'dragon_tiger',
      'egypt_s_book_of_mystery',
      'four_dragons',
      'genie_jackpots',
      'iron_bank',
      'money_train2',
      'ramses_revenge',
      'roma',
      'sanquentin',
      'sweet_bonanza',
      'thor',
      'vikings',
      'wild_west',
    ];
  }
}
